module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 3
// module chunks = 0